import { tagged } from "@mirage/service-logging";
import { fetchUserEligibility } from "@mirage/shared/eligibility";
import { useEffect, useState } from "react";

const logger = tagged("useCanSeeInviteForm");
export const useCanSeeInviteForm = () => {
  const [canSeeInviteForm, setCanSeeInviteForm] = useState(false);

  useEffect(() => {
    const fetchCanSeeInviteForm = async () => {
      try {
        const response = await fetchUserEligibility();
        setCanSeeInviteForm(
          response?.dash_user_attributes?.can_see_dfb_invite_member_form ??
            false,
        );
      } catch (e) {
        logger.error("failed to get canSeeDfbInviteMemberForm", e);
        setCanSeeInviteForm(false);
      }
    };

    fetchCanSeeInviteForm();
  }, []);

  return canSeeInviteForm;
};
